module.exports = __webpack_public_path__ + "a21320f85635ff6c05a148310b72bd82.pdf";